/**
 * Auto-generated executive summary text per map type.
 * Pure function: takes stats + config, returns a single paragraph.
 */
// State-level narrative flavor — cited grant programs / regulatory agencies
// that make the summary read as regionally specific.
const STATE_CONTEXT = {
  VA: 'VDOT crash data + SS4A eligibility',
  MD: 'MDOT SHA + Maryland Vision Zero',
  SC: 'SCDOT + Palmetto Priority Safety corridors',
  NC: 'NCDOT strategic mobility formula + Vision Zero NC',
  FL: 'FDOT + Target Zero',
  CA: 'Caltrans SHOPP + California Vision Zero',
};

export function executiveSummary(mapType, stats, config) {
  const loc = config.cityName
    ? `${config.cityName}, ${config.state || ''}`.trim().replace(/,$/, '')
    : config.locLabel || 'the study area';
  const stateTail = config.state && STATE_CONTEXT[config.state]
    ? ` Aligned to ${STATE_CONTEXT[config.state]}.`
    : '';
  switch (mapType) {
    case 'crash_safety':
      return (
        `${stats.hotspot_count} high-frequency crash clusters identified within ${loc} ` +
        `(${stats.area_sq_mi} sq mi, ${stats.total_incidents} incidents, ${stats.fatal_count} severe/fatal). ` +
        `Recommended next step: signal-timing audit and pedestrian-crossing review at the highest-severity hotspot.` +
        stateTail
      );
    case 'event_ops':
      return (
        `Event footprint covers ${loc} with an estimated capacity of ${stats.capacity_estimate.toLocaleString()}. ` +
        `${stats.gate_count} gates and ${stats.medical_capacity}-bed medical support are positioned for ingress/egress. ` +
        `Vendor zones (${stats.vendor_zones}) anchor concession flow; egress routes provide a 10-minute clearance estimate.`
      );
    case 'permit_row':
      return (
        `Project corridor in ${loc} affects ${stats.parcels_affected} parcels across ${stats.row_length_mi} miles. ` +
        `${stats.permit_count} permit applications mapped along the alignment. ` +
        `Utility coordination required with ${stats.easements} active easement.` +
        stateTail
      );
    case 'emergency_response':
      return (
        `Response footprint in ${loc} includes ${stats.response_assets} primary assets covering ${stats.coverage_sq_mi} sq mi. ` +
        `${stats.hazard_type[0].toUpperCase() + stats.hazard_type.slice(1)} hazard zone impacts the central population. ` +
        `Shelter capacity ~${stats.shelter_capacity.toLocaleString()}. Recommended pre-positioning at the EOC.` +
        stateTail
      );
    default:
      return `Demonstration map for ${loc}.`;
  }
}
